var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{attrs:{"value":"1","unchecked-value":"0"},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=_vm._n($$v)},expression:"internalValue"}},[_vm._v("\n  "+_vm._s(_vm.$t('Show deleted'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }